import { render, staticRenderFns } from "./GCompetencyLabel.vue?vue&type=template&id=2a39a2cc&"
import script from "./GCompetencyLabel.vue?vue&type=script&lang=ts&"
export * from "./GCompetencyLabel.vue?vue&type=script&lang=ts&"
import style0 from "./GCompetencyLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports